import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class SecondaryMenu extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    return (
      <div className="secondary-menu">
        {this.props.children}
      </div>
    );
  }
}

export default SecondaryMenu;
